import mapRuntimeEnvVar from "./mapRuntimeEnvVar";

const config = {
  AUTH0_DOMAIN: mapRuntimeEnvVar("REACT_APP_AUTH0_DOMAIN"),
  AUTH0_AUDIENCE: mapRuntimeEnvVar("REACT_APP_AUTH0_AUDIENCE"),
  AUTH0_CLIENT_ID: mapRuntimeEnvVar("REACT_APP_AUTH0_CLIENT_ID"),
};

export default config;
